"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = now;
/**
 * direttiva di test per verificare quando vengono istanziati i controller
 */
function now() {
  var count = 0;
  function link(scope, element) {
    //element.text((count++) +' '+ moment().format('HH:mm:ss.SSS'));
  }

  return {
    link: link
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/now.directive.js
// module id = 146
// module chunks = 2